import React, { ReactNode } from 'react';

type Props = {
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	label: string;
	value: string | number;
	extensions?: ReactNode;
};

const AccountElement: React.FC<Props> = ({
	icon: Icon,
	label,
	value,
	extensions,
}) => (
	<div className='flex items-center gap-4'>
		<div className='p-1.5 rounded-semi-xl bg-popover-100'>
			<Icon />
		</div>
		<div className='mr-auto text-sm'>
			<h4 className='text-popover-600'>{label}</h4>
			<p className='ml-auto'>{value}</p>
		</div>
		{extensions && <>{extensions}</>}
	</div>
);

export default AccountElement;
